import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Profile = ({ user: currentUser, onUserUpdate }) => {
  const [formData, setFormData] = useState({
    email: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    if (currentUser) {
      setFormData(prev => ({ ...prev, email: currentUser.email || '' }));
    }
  }, [currentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: 'error', text: 'Passwörter stimmen nicht überein' });
      return;
    }

    try {
      const updateData = {
        email: formData.email,
        ...(formData.newPassword && { password: formData.newPassword })
      };

      const response = await axios.put('/api/profile', updateData);
      
      setMessage({ type: 'success', text: 'Profil erfolgreich aktualisiert' });
      setFormData(prev => ({
        ...prev,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }));
      
      if (onUserUpdate) {
        onUserUpdate(response.data);
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.error || 'Fehler beim Aktualisieren' 
      });
    }
  };

  return (
    <>
      <style>
        {`
          .button-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid rgba(255,255,255,0.2);
            padding: 0.75rem 1.5rem;
            borderRadius: 12px;
            cursor: pointer;
            fontSize: 0.95rem;
            fontWeight: 600;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            boxShadow: 0 8px 16px rgba(59, 130, 246, 0.3), inset 0 1px 2px rgba(255,255,255,0.2);
            position: relative;
            overflow: hidden;
          }

          .button-primary::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
          }

          .button-primary:hover::before {
            width: 400px;
            height: 400px;
          }

          .button-primary:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            transform: translateY(-3px) scale(1.02);
            box-shadow: 0 15px 35px rgba(59, 130, 246, 0.5), 0 0 30px rgba(59, 130, 246, 0.3);
          }

          .button-primary:active {
            transform: translateY(-1px) scale(1);
          }

          .profile-input {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .profile-input:focus {
            border-color: #3b82f6 !important;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 8px 16px rgba(59, 130, 246, 0.2);
            transform: translateY(-2px);
            outline: none;
          }

          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            75% { transform: translateX(5px); }
          }

          .message-box {
            animation: slideIn 0.4s ease-out;
          }

          .message-box.error {
            animation: slideIn 0.4s ease-out, shake 0.5s ease-out 0.4s;
          }

          .profile-card {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .profile-card:hover {
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          }

          .input-disabled {
            transition: all 0.3s ease;
          }

          .input-disabled:hover {
            background: #f1f5f9 !important;
          }
        `}
      </style>

      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <h1 style={{ color: '#1e293b', fontSize: '2rem', marginBottom: '0.5rem' }}>
          Mein Profil
        </h1>
        <p style={{ color: '#64748b', marginBottom: '2rem' }}>
          Verwalten Sie Ihre persönlichen Daten
        </p>

        {message.text && (
          <div 
            className={`message-box ${message.type}`}
            style={{
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1.5rem',
              background: message.type === 'success' ? '#d1fae5' : '#fee2e2',
              color: message.type === 'success' ? '#065f46' : '#991b1b',
              border: `2px solid ${message.type === 'success' ? '#10b981' : '#ef4444'}`,
              fontWeight: '500',
              boxShadow: message.type === 'success' 
                ? '0 4px 12px rgba(16, 185, 129, 0.2)'
                : '0 4px 12px rgba(239, 68, 68, 0.2)'
            }}
          >
            {message.text}
          </div>
        )}

        <div 
          className="profile-card"
          style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2rem',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}
        >
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Benutzername
              </label>
              <input
                type="text"
                value={currentUser?.username || ''}
                disabled
                className="input-disabled"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  background: '#f8fafc',
                  color: '#94a3b8',
                  cursor: 'not-allowed'
                }}
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                E-Mail
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="profile-input"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #e2e8f0' }} />

            <h3 style={{ color: '#1e293b', marginBottom: '1rem' }}>Passwort ändern</h3>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Neues Passwort
              </label>
              <input
                type="password"
                value={formData.newPassword}
                onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                className="profile-input"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Passwort bestätigen
              </label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                className="profile-input"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <button type="submit" className="button-primary" style={{ width: '100%' }}>
              Änderungen speichern
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Profile;